export default __webpack_public_path__ + "static/media/definition_white.3ac0c9c5.svg";